import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
export const useStakingInterestSchedule = () => {
    const ADD_ONE_DAY = 1;
    const getDateNow = (date) => {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    };
    //get start date + 1 day
    const getStartDate = (date) => {
        return dayjs(date).add(ADD_ONE_DAY, 'day').format('YYYY-MM-DD') + ' 00:00:00';
    };
    //get maturity date ( start date + term day )
    const getMaturityDate = (date, term) => {
        return dayjs(date).add(term, 'day').format('YYYY-MM-DD') + ' 00:00:00';
    };
    //get redemption date (maturity date + 1 day + 1 hour
    const ADD_ONE_HOUR = dayjs.duration(1, 'hours');
    const getRedemptionDate = (date, term) => {
        return dayjs(getMaturityDate(date, term)).add(ADD_ONE_DAY, 'day').add(ADD_ONE_HOUR).format('YYYY-MM-DD HH:mm:ss');
    };
    return { getStartDate, getDateNow, getMaturityDate, getRedemptionDate };
};
